import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import {
  getAMLSTMCommonTransactionHistory,
  downloadAMLSTMCommonTransactionHistory,
  getAMLSTMCommonTransactionTriggeredTypologies,
  getAMLSTMCommonTransactionTriggeredVariants
} from '../../../redux/actions/tmCommon';
import { getAMLSCommonAlertPartyIdentity } from '../../../redux/actions/common';
import TransactionDetails from './TransactionDetails';

const mapStateToProps = (state) => {
  const { alertPartyIdentity = {}, alertDetails = {} } = state.amlsCommon;
  const {
    transactionHistory = {},
    transactionHistoryDownloaded = {},
    transactionTriggeredTypologies = {},
    transactionTriggeredVariants
  } = state.amlsTMCommon;
  const { data: transactionHistoryData, error, isLoading } = transactionHistory;
  const { data: customerInfo, isLoading: isCustomerInfoLoading } =
    alertPartyIdentity;
  const { data: typologies } = transactionTriggeredTypologies;
  const { partyKey = '' } = customerInfo || {};
  const { data: transactionHistoryDownloadedData } =
    transactionHistoryDownloaded;

  return {
    transactionHistory: transactionHistoryData,
    transactionHistoryDownloaded: transactionHistoryDownloadedData,
    error,
    isLoading,
    isCustomerInfoLoading,
    customerId: partyKey,
    typologies,
    alertDetails,
    transactionTriggeredVariants
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    apiActions: bindActionCreators(
      {
        getAMLSCommonAlertPartyIdentity,
        getAMLSTMCommonTransactionHistory,
        getAMLSTMCommonTransactionTriggeredTypologies,
        getAMLSTMCommonTransactionTriggeredVariants,
        downloadAMLSTMCommonTransactionHistory
      },
      dispatch
    )
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(TransactionDetails);
